import React, { useState } from 'react';
import { Container, Row, Col, Button, Form, Modal, Card } from 'react-bootstrap';
import PageTitle from '@/common/PageTitle/PageTitle';
import styles from '@/styles/inventory-warehouse.module.scss';
import pageStyles from './wearhouse.module.scss';
import warehouse1Image from '@/assets/images/warehouse1.jpg';
import warehouse2Image from '@/assets/images/warehouse2.jpg';

const wearhouses = [
  {
    name: 'Georgia, US',
    image: warehouse1Image,
    employees: 23,
    items: 308,
    orders: 2,
    refunds: 1,
    mostSold: 'KrossKast Players',
    mostPopularCategory: 'KK Players',
    satisfaction: '93%',
    status: 'Open',
    gallery: [
      warehouse1Image,
    ],
  },
  {
    name: 'Florida, US',
    image: warehouse2Image,
    employees: 15,
    items: 120,
    orders: 1,
    refunds: 0,
    mostSold: 'Denim Shorts Women',
    mostPopularCategory: 'Bottoms',
    satisfaction: '89%',
    status: 'Open',
    gallery: [
      warehouse2Image,
    ],
  },


];

const Wearhouse: React.FC = () => {
  const [selected, setSelected] = useState(0);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [editingWarehouse, setEditingWarehouse] = useState<any>(null);
  const [newWarehouse, setNewWarehouse] = useState({
    name: '',
    image: warehouse1Image,
    employees: 0,
    items: 0,
    orders: 0,
    refunds: 0,
    mostSold: '',
    mostPopularCategory: '',
    satisfaction: '90%',
    status: 'Open',
    gallery: [warehouse1Image],
  });
  const [warehouses, setWarehouses] = useState(wearhouses);
  const selectedWearhouse = warehouses[selected];

  const handleEditWarehouse = (warehouse: any) => {
    setEditingWarehouse({ ...warehouse });
    setShowEditModal(true);
  };

  const handleSaveWarehouse = () => {
    if (editingWarehouse) {
      const updatedWarehouses = warehouses.map((wh, index) => 
        index === selected ? editingWarehouse : wh
      );
      setWarehouses(updatedWarehouses);
      setShowEditModal(false);
      setEditingWarehouse(null);
    }
  };

  const handleImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file && editingWarehouse) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setEditingWarehouse({
          ...editingWarehouse,
          image: e.target?.result as string
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const handleNewWarehouseImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setNewWarehouse({
          ...newWarehouse,
          image: e.target?.result as string,
          gallery: [e.target?.result as string]
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const handleAddWarehouse = () => {
    if (newWarehouse.name.trim()) {
      const warehouseToAdd = {
        ...newWarehouse,
        name: newWarehouse.name.trim()
      };
      setWarehouses([...warehouses, warehouseToAdd]);
      setNewWarehouse({
        name: '',
        image: warehouse1Image,
        employees: 0,
        items: 0,
        orders: 0,
        refunds: 0,
        mostSold: '',
        mostPopularCategory: '',
        satisfaction: '90%',
        status: 'Open',
        gallery: [warehouse1Image],
      });
      setShowAddModal(false);
    }
  };

  const handleDeleteWarehouse = () => {
    setShowDeleteConfirmModal(true);
  };

  const confirmDeleteWarehouse = () => {
    if (editingWarehouse) {
      const updatedWarehouses = warehouses.filter((wh, index) => index !== selected);
      setWarehouses(updatedWarehouses);
      setShowEditModal(false);
      setShowDeleteConfirmModal(false);
      setEditingWarehouse(null);
      setSelected(-1); // Deselect the deleted warehouse
    }
  };

  const handleInputChange = (field: string, value: any) => {
    setNewWarehouse({
      ...newWarehouse,
      [field]: value
    });
  };

  return (
    <Container fluid>
      <Card className={pageStyles.card}>
        <Card.Body>
          <Card.Title className={pageStyles.cardTitle}>
            <PageTitle title="Warehouses" />
            <div className={styles.headerActions}>
              <Form.Select className={styles.filterSelect}>
                <option>Filter by</option>
              </Form.Select>
              <Button className={styles.addButton} onClick={() => setShowAddModal(true)}>
                + Add Warehouse
              </Button>
            </div>
          </Card.Title>
      <Form className={styles.searchForm}>
        <Form.Control
          className={styles.searchInput}
          placeholder="Search"
        />
      </Form>
      <Row className={styles.warehousesRow}>
        {warehouses.map((wh, idx) => (
          <Col key={wh.name} md={3} sm={6} xs={12} className={styles.warehouseCol}>
            <div
              onClick={() => setSelected(idx)}
              className={`${styles.warehouseCard} ${idx === selected ? styles.warehouseCardSelected : ''}`}
            >
              <img src={wh.image} alt={wh.name} className={styles.warehouseImage} />
              <div className={styles.warehouseName}>{wh.name}</div>
            </div>
          </Col>
        ))}
      </Row>
      {/* Details Panel */}
      {selectedWearhouse && (
        <div className={styles.detailsPanel}>
          <div className={styles.detailsHeader}>
            <h3 className={styles.detailsTitle}>{selectedWearhouse.name}</h3>
            <div className={styles.detailsActions}>
              <Button
                variant="outline-primary"
                size="sm"
                onClick={() => handleEditWarehouse(selectedWearhouse)}
                className={styles.editButton}
              >
                Edit Warehouse
              </Button>
              <Button
                variant="link"
                className={styles.closeButton}
                onClick={() => setSelected(-1)}
              >
                ×
              </Button>
            </div>
          </div>

          <div className={styles.warehouseImageContainer}>
            <img 
              src={selectedWearhouse.image} 
              alt={`${selectedWearhouse.name} warehouse`} 
              className={styles.warehouseDetailImage}
            />
          </div>

          <div className={styles.detailsContent}>
            <div>
              <div className={styles.detailItem}>Employees: {selectedWearhouse.employees}</div>
              <div className={styles.detailItem}>Items: {selectedWearhouse.items}</div>
              <div className={styles.detailItem}>Orders: {selectedWearhouse.orders}</div>
              <div className={styles.detailItem}>Refunds: {selectedWearhouse.refunds}</div>
            </div>
            <div>
              <div className={styles.detailItem}>Most sold items: {selectedWearhouse.mostSold}</div>
              <div className={styles.detailItem}>Most popular category: {selectedWearhouse.mostPopularCategory}</div>
              <div className={styles.detailItem}>Customer satisfaction: {selectedWearhouse.satisfaction}</div>
              <div className={styles.detailItem}>Status: {selectedWearhouse.status}</div>
            </div>
          </div>
        </div>
      )}

      {/* Edit Warehouse Modal */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Edit Warehouse</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {editingWarehouse && (
            <Form>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Warehouse Name</Form.Label>
                    <Form.Control
                      type="text"
                      value={editingWarehouse.name}
                      onChange={(e) => setEditingWarehouse({
                        ...editingWarehouse,
                        name: e.target.value
                      })}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Status</Form.Label>
                    <Form.Select
                      value={editingWarehouse.status}
                      onChange={(e) => setEditingWarehouse({
                        ...editingWarehouse,
                        status: e.target.value
                      })}
                    >
                      <option value="Open">Open</option>
                      <option value="Closed">Closed</option>
                      <option value="Maintenance">Maintenance</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Number of Employees</Form.Label>
                    <Form.Control
                      type="number"
                      value={editingWarehouse.employees}
                      onChange={(e) => setEditingWarehouse({
                        ...editingWarehouse,
                        employees: parseInt(e.target.value) || 0
                      })}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Number of Items</Form.Label>
                    <Form.Control
                      type="number"
                      value={editingWarehouse.items}
                      onChange={(e) => setEditingWarehouse({
                        ...editingWarehouse,
                        items: parseInt(e.target.value) || 0
                      })}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Most Sold Item</Form.Label>
                    <Form.Control
                      type="text"
                      value={editingWarehouse.mostSold}
                      onChange={(e) => setEditingWarehouse({
                        ...editingWarehouse,
                        mostSold: e.target.value
                      })}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Most Popular Category</Form.Label>
                    <Form.Control
                      type="text"
                      value={editingWarehouse.mostPopularCategory}
                      onChange={(e) => setEditingWarehouse({
                        ...editingWarehouse,
                        mostPopularCategory: e.target.value
                      })}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Customer Satisfaction (%)</Form.Label>
                    <Form.Control
                      type="text"
                      value={editingWarehouse.satisfaction}
                      onChange={(e) => setEditingWarehouse({
                        ...editingWarehouse,
                        satisfaction: e.target.value
                      })}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Current Image</Form.Label>
                    <div className="mb-2">
                      <img 
                        src={editingWarehouse.image} 
                        alt="Current warehouse" 
                        className={pageStyles.imagePreview}
                      />
                    </div>
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={handleImageUpload}
                    />
                    <Form.Text className="text-muted">
                      Upload a new image to replace the current one
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-between w-100">
            <Button variant="danger" onClick={handleDeleteWarehouse}>
              Delete Warehouse
            </Button>
            <div>
              <Button variant="secondary" onClick={() => setShowEditModal(false)}>
                Cancel
              </Button>
              <Button variant="primary" onClick={handleSaveWarehouse} className="ms-2">
                Save Changes
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/* Add Warehouse Modal */}
      <Modal show={showAddModal} onHide={() => setShowAddModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Add New Warehouse</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Warehouse Name *</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter warehouse name"
                    value={newWarehouse.name}
                    onChange={(e) => handleInputChange('name', e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Status</Form.Label>
                  <Form.Select
                    value={newWarehouse.status}
                    onChange={(e) => handleInputChange('status', e.target.value)}
                  >
                    <option value="Open">Open</option>
                    <option value="Closed">Closed</option>
                    <option value="Maintenance">Maintenance</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Number of Employees</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="0"
                    value={newWarehouse.employees}
                    onChange={(e) => handleInputChange('employees', parseInt(e.target.value) || 0)}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Number of Items</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="0"
                    value={newWarehouse.items}
                    onChange={(e) => handleInputChange('items', parseInt(e.target.value) || 0)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Most Sold Item</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter most sold item"
                    value={newWarehouse.mostSold}
                    onChange={(e) => handleInputChange('mostSold', e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Most Popular Category</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter most popular category"
                    value={newWarehouse.mostPopularCategory}
                    onChange={(e) => handleInputChange('mostPopularCategory', e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Customer Satisfaction (%)</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="90%"
                    value={newWarehouse.satisfaction}
                    onChange={(e) => handleInputChange('satisfaction', e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Warehouse Image</Form.Label>
                  <div className="mb-2">
                    <img 
                      src={newWarehouse.image} 
                      alt="Warehouse preview" 
                      className={pageStyles.imagePreview}
                    />
                  </div>
                  <Form.Control
                    type="file"
                    accept="image/*"
                    onChange={handleNewWarehouseImageUpload}
                  />
                  <Form.Text className="text-muted">
                    Upload an image or use the default warehouse image
                  </Form.Text>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAddModal(false)}>
            Cancel
          </Button>
          <Button 
            variant="primary" 
            onClick={handleAddWarehouse}
            disabled={!newWarehouse.name.trim()}
          >
            Add Warehouse
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal show={showDeleteConfirmModal} onHide={() => setShowDeleteConfirmModal(false)} size="sm">
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete this warehouse?</p>
          <p className="text-muted mb-0">
            <strong>{editingWarehouse?.name}</strong>
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteConfirmModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmDeleteWarehouse}>
            Delete Warehouse
          </Button>
        </Modal.Footer>
      </Modal>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Wearhouse; 